import { ILanguage } from "../types";

export const fr: ILanguage = {
  translation: {
    root: {
      customize: "Personnaliser",
      businessAccount: "Compte professionnel",
      verificationStatus: "Statut de vérification",
      companyInformation: "INFORMATIONS SUR L'ENTREPRISE",
      note: "Remarque",
      businessName: "Nom de l'entreprise",
      enterBusinessName: "Entrez le nom de l'entreprise",
      registrationNumber: "N° d'immatriculation",
      registrationNumberPlaceholder: "Entrez le numéro d'immatriculation",
      taxVat: "N° d'immatriculation fiscale/TVA",
      vatPlaceholder: "Entrez le numéro fiscal/TVA",
      registeredAddress: "Adresse enregistrée*",
      tradingAddress: "Adresse commerciale*",
      sameAsRegisteredAddress: "Identique à l'adresse enregistrée",
      billingInformation: "Informations de facturation",
      billingPhoneNo: "Tél. de facturation*",
      mode: "Mode",
      comments: "Commentaires",
      phonePlaceholder: "Entrez le numéro de téléphone",
      billingEmail: "Email de facturation*",
      emailPlaceholder: "Entrez l'email de facturation",
      driverDetails: "Détails du conducteur",
      customerVerificationStatus: "Statut de vérification du client",
      enterNationalInsuranceNumber: "Entrez le numéro de sécurité sociale",
      enterYourProfession: "Entrez votre profession",
      enterDriving: "Entrez le permis de conduire",
      profileImage: "photo de profil",
      number: "Numéro",
      image: "Image",
      uploadBack: "Télécharger verso",
      uploadFront: "Télécharger recto",
      issuedBy: "Délivré par",
      document: "Document",
      middleName: "Deuxième prénom",
      middleNameLabel: "Deuxième prénom",
      enterMiddleName: "Entrez le deuxième prénom",
      selectDocument: "Sélectionner un document",
      addFile: "Ajouter un fichier",
      noDataFound: "Aucune donnée trouvée",
      noDocumentsFound: "Aucun document trouvé",
      documentUpdatedAt: "Document mis à jour le",
      editExpiryDate: "Modifier la date d'expiration",
      selectExpiryDate: "Sélectionner la date d'expiration",
      selectExpiryDateUpload:
        "Veuillez sélectionner la date d'expiration avant de télécharger.",
      status: "Statut",
      images: "Images",
      profession: "Profession",
      nationality: "Nationalité",
      driving: "Permis de conduire",
      listOfDocumentsUploaded: "Liste des documents téléchargés",
      listOfRequiredDocumentsUploaded: "Liste des documents requis téléchargés",
      documentType: "Type de document",
      documentName: "Nom du document",
      expiryDate: "Date d'expiration",
      confirmDelete: "Confirmer la suppression",
      actions: "Actions",
      completed: "Terminé",
      pending: "En attente",
      documentDeleteConfirmMsg:
        "Êtes-vous sûr de vouloir supprimer ce document ?",
      address: "Adresse",
      useRegisteredAddress: "Utiliser l'adresse enregistrée",
      billingEmailAddress: "Adresse email de facturation*",
      billingEmailLabel: "Adresse email de facturation",
      accountNumber: "Numéro de compte",
      firstName: "Prénom*",
      lastName: "Nom*",
      firstNameLabel: "Prénom",
      lastNameLabel: "Nom",
      contactEmail: "Email de contact*",
      emailLabel: "Adresse email",
      contactPhone: "Téléphone de contact*",
      registeredAddressCaps: "ADRESSE ENREGISTRÉE",
      tradingAddressCaps: "ADRESSE COMMERCIALE",
      billingInformationCaps: "INFORMATIONS DE FACTURATION",
      customerContactCaps: "CONTACT CLIENT",
      contactEmailInvalid: "Veuillez entrer un email de contact valide.",
      typeAddress: "Tapez l'adresse",
      taxFees: "Taxes et frais",
      vatTax: "TVA/IMPÔT",
      registrationNum: "Numéro d'enregistrement",
      drivingLicenceNumber: "Numéro de permis de conduire",
      invalidPhoneNumber: "Numéro de téléphone invalide",
      onStartEmail: "Nous vous avons envoyé un email pour démarrer.",
      emailNotSeen:
        "Si vous ne voyez pas l'email dans quelques minutes, vérifiez votre dossier 'Spam'.",
      registerNow: "S'inscrire maintenant",
      email: "Email",
      thankYou: "Merci",
      pickUpLocation: "Lieu de prise en charge",
      returnLocation: "Lieu de retour *",
      pickUpDate: "Date enlèvement *",
      pickUpTime: "Heure de retrait *",
      invalidPickupLeadTime: "La date/heure de retrait sélectionnée est en dehors de la fenêtre de réservation autorisée",
      dropOffDate: "Date de retour *",
      searchVehicles: "Rechercher des véhicules",
      chooseLocation: "Entrez un emplacement ou un code postal",
      vehicleGallery: "Galerie de véhicules",
      privacyPolicy: "Politique de confidentialité",
      termsAndConditions: "Termes et conditions",
      dropOffTime: "Heure de retour *",
      noVehiclesFound: "Aucun véhicule trouvé correspondant aux critères",
      noRecordFound: "Désolé, aucun enregistrement correspondant trouvé !",
      vehicles: "Véhicules",
      endDate: "Date de fin",
      startDate: "Date de début",
      past: "Passé",
      search: "Rechercher",
      upcoming: "À venir",
      current: "Actuel",
      all: "Tous",
      more: "Plus",
      toBeAssigned: "À attribuer",
      ref: "réf",
      reservation: "Réservation",
      booking: "Réservation",
      pricingSummary: "Résumé des tarifs",
      bookingSummary: "Résumé de la réservation",
      subscriptionVehicle: "Véhicule d'abonnement",
      insurance: "Assurance",
      addons: "Suppléments",
      protectionPlan: "Plan de protection",
      initialRental: "Paiement initial de location",
      enrollmentFee: "Frais d'inscription",
      quantity: "Quantité",
      subscriptionPrice: "Prix de l'abonnement",
      weekly: "Hebdomadaire",
      monthly: "Mensuel",
      on: "Le",
      numberOfDoors: "Nombre de portes",
      numberOfSeats: "Nombre de sièges",
      transmission: "Transmission",
      fuelType: "Type de carburant",
      week: "Semaine",
      day: "Jour",
      hour: "Heure",
      month: "Mois",
      gropu1Icon: "icône groupe 1",
      vatInclusive: "TVA INCLUSE",
      vat: "TVA",
      rental: "Location",
      speedometer: "Compteur de vitesse",
      available: "Disponible",
      priceLowToHigh: "Prix croissants",
      priceHighToLow: "Prix décroissants",
      weHaveSmartCars: "Nous proposons des voitures intelligentes",
      keylessSupport:
        "Accès sans clé disponible sur nos véhicules intelligents",
      keylessVehicles: "Afficher les véhicules sans clé",
      duration: "Durée",
      swapsAllowed: "Échanges autorisés",
      enrollmentAmount: "Montant de l'inscription",
      subscriptionAmount: "Montant de l'abonnement",
      mileageLimit: "Limite de kilométrage",
      unlimited: "Illimité",
      weeks: "Semaines",
      months: "Mois",
      pricePerExtraMile: "Prix par mile supplémentaire",
      insurancePolicy: "Police d'assurance",
      removeSubscription: "Supprimer l'abonnement",
      noGroupFound: "Aucun groupe correspondant trouvé !",
      vehicleTypeIcon: "icône type de véhicule",
      min: "Min",
      selected: "Sélectionné",
      vehiclesSelected: "Véhicules sélectionnés",
      selectVehicles: "Sélectionner des véhicules",
      personalDetails: "Détails personnels",
      selectAddons: "Sélectionner des suppléments",
      continue: "Continuer",
      locationSurcharge: "Supplément de localisation",
      onTotalRentalAmount: "Sur le montant total de la location",
      oneWayFee: "Frais aller simple",
      oneWayRentalCharge: "Frais de location aller simple",
      total: "Total",
      firstMonthTotal: "Total du premier mois",
      firstWeekTotal: "Total de la première semaine",
      depositPayable: "Dépôt (Payable lors de la prise en charge)",
      deposit: "Dépôt",
      insuranceCaps: "ASSURANCE",
      customAddon: "supplément personnalisé",
      chooseAPolicy: "Choisir une police",
      rate: "Tarif",
      typeOfValet: "Type de voiturier",
      nonNegotiable: "Non négociable",
      selectValet: "Sélectionner un voiturier",
      collectionAddress: "Adresse de collecte",
      remove: "Supprimer",
      deliveryAddress: "Adresse de livraison",
      additionalInformation: "Informations complémentaires",
      confirmBooking: "Confirmer la réservation",
      proceed: "Procéder",
      getQuote: "Obtenir un devis",
      for: "Pour",
      agreeWithTermsAndConditions: "J'accepte les termes et conditions",
      selectCostCenter: "Sélectionner un centre de coût pour la réservation",
      action: "Action",
      name: "Nom",
      enterDrivingLicenceNumber: "Entrez le numéro de permis de conduire",
      enterLastName: "Entrez le nom",
      enterFirstName: "Entrez le prénom",
      enterYourMail: "Entrez votre email",
      emailAsterisk: "Email*",
      quoteGeneratedCaps: "DEVIS GÉNÉRÉ",
      updated: "mis à jour",
      rentalCharges: "Frais de location",
      totalPayableAmount: "Montant total à payer",
      payMinimumAmount: "Payer le montant minimum",
      dueAmountPaidWhilePickup:
        "Montant dû à régler lors de la prise en charge",
      payOnCollection: "Payer à la prise en charge",
      CardAuthorization:
        "La carte sera autorisée maintenant mais le montant sera prélevé quand",
      starts: "commence",
      confirm: "Confirmer",
      payAtTimeOfPickup: "maintenant et payez à la prise en charge",
      payFullAmountNow: "Payer le montant total maintenant",
      payFullAmountRightAway: "Payer immédiatement le montant total",
      FutureChargesRelatedToOngoingBooking:
        "Les frais futurs liés à la réservation en cours seront débités sur ce mode de paiement",
      saveThisCardForFutureInvoices:
        "Enregistrer cette carte pour payer les prochaines factures sur ce {{bookingSyntax}}",
      payLater: "Payer plus tard",
      creditLimitAssigned:
        "Le crédit attribué à cette entreprise sera utilisé pour ce paiement",
      CreditsAgainstBooking:
        "Les crédits seront utilisés pour cette réservation",
      useCreditNoteBalance: "Utiliser le solde du bulletin de crédit",
      telNo: "Tél. No.",
      vatNo: "N° de TVA",
      customer: "Client",
      emailAddress: "Adresse email",
      phoneNumber: "Numéro de téléphone",
      dateCreated: "Date de création",
      poNumber: "N° de commande",
      dateTime: "Date & Heure",
      dropOffLocation: "Lieu de restitution",
      contractHire: "Contrat de location",
      subscription: "Abonnement",
      charges: "Frais",
      enrollmentFees: "Frais d'inscription",
      na: "N/A",
      grandTotal: "Total général",
      rentalPrice: "Prix de location",
      daysProRated: "jours au prorata",
      locationSurcharges: "Suppléments de localisation",
      ofTotalRentalAmount: "du montant total de la location",
      nextBilling: "Prochaine facturation",
      subTotal: "Sous-total",
      discount: "Remise",
      discountedPrice: "Prix réduit",
      description: "DESCRIPTION",
      descriptionLabel: "Description",
      thisIsA: "Ceci est un(e)",
      exemptedBooking: "réservation exonérée",
      thisIstestCourtsey: "Ceci est un essai/courtoisie",
      isCalculatedAgainst: "est calculé contre",
      priceAndSelectedAddons:
        "Prix et quelques suppléments sélectionnés hors assurance et dépôt",
      recurringWeeklyMonthlyInvoice:
        "Une facture récurrente hebdomadaire/mensuelle sera générée automatiquement pour la semaine/mois suivant.",
      additionalNote: "Note supplémentaire",
      payableAtVehicleCollection:
        "Payable lors de la prise en charge du véhicule",
      purchaseOrderUpdated: "numéro de commande mis à jour avec succès",
      proceedToPay: "Procéder au paiement",
      searchResults: "Résultats de recherche",
      subscriptions: "Abonnements",
      contractHireVehicleWeeklyMonthly:
        "Véhicule en contrat de location hebdomadaire/mensuel",
      subscribeVehicleWeeklyMonthly: "Abonnez-vous au véhicule semaine/mois",
      contractNow: "Contracter maintenant",
      subscribeNow: "S'abonner maintenant",
      backToBookingCategorySelection:
        "Retour à la sélection des catégories de réservation.",
      accountVerification: "Vérification du compte",
      profileNotVerifiedMessage:
        "Votre profil n'a pas été vérifié. Veuillez contacter votre opérateur pour compléter le processus de vérification et continuer.",
      update: "Mettre à jour",
      reference: "Référence",
      companyRegistrationNumber: "N° d'immatriculation",
      availableFrom: "Disponible à partir de",
      paellaDish: "Plat de paella",
      vehicleCatalogues: "Catalogues de véhicules",
      vehicleDetails: "Détails du véhicule",
      verification: "Vérification",
      protectionPlans: "Plans de protection",
      authorisedSignatory: "Signataire autorisé",
      item: "Article",
      price: "Prix",
      unitPrice: "Prix unitaire",
      vehicleSpecification: "Spécifications du véhicule",
      model: "Modèle",
      color: "Couleur",
      bodyType: "Type de carrosserie",
      tankCapacity: "Capacité du réservoir",
      interiorColor: "Couleur intérieure",
      seats: "Sièges",
      doors: "Portes",
      whatsIncluded: "Ce qui est inclus",
      timeVehicleSwap: "Échange de véhicule",
      contractualDetails: "Détails contractuels",
      longerSubscribeSaveMore:
        "Plus la souscription est longue, plus vous économisez",
      tailorSubscriptionToNeeds: "Adaptez votre abonnement selon vos besoins",
      easyManagementOnline: "Gestion facile et fluide en ligne",
      SwapCarAndCancel: "Changez de voiture ou annulez à tout moment",
      customizeYourContract: "Personnalisez votre contrat",
      selectPlan: "Sélectionnez un plan",
      selectTenure: "Sélectionnez la durée",
      tentativeStartDate: "Date de début provisoire",
      selectDate: "Sélectionnez la date",
      selectTime: "Sélectionnez l'heure",
      contractSummary: "Résumé de votre contrat",
      subscriptionChargesLabel: "Frais d’abonnement",
      initialRentalPayment: "Paiement initial",
      continueToPersonalDetails: "Continuer vers les détails personnels",
      noAvailableAddonsFound:
        "Aucun supplément disponible correspondant à vos critères",
      nationalInsuranceNumber: "Numéro de sécurité sociale",
      updateQuote: "Mettre à jour le devis",
      driverNotAvailable:
        "Conducteur non disponible, veuillez contacter l’opérateur",
      selectDeliverySlot: "Choisir une plage de livraison",
      wantDelivered: "Souhaitez-vous la livraison ?",
      verifyYourLicenceCaps: "VÉRIFIEZ VOTRE PERMIS",
      validateAllFieldsForLicenceCheck:
        "Veuillez remplir tous les champs pour vérifier le permis. Tous sont obligatoires.",
      postCode: "Code postal",
      thisAgreementAllows: "Cet accord permet",
      leftoverAgreement:
        "et à notre partenaire d’assurance d’effectuer les vérifications nécessaires...",
      verifyLicence: "Vérifier le permis",
      licenceCheckingInProgress: "Vérification du permis en cours",
      checkingInProgress:
        "Cela peut prendre jusqu’à 2 minutes, veuillez patienter et ne pas rafraîchir la page",
      licenceCheckingFailed: "Échec de la vérification du permis",
      checkForCorrectDetails: "Veuillez vérifier les détails saisis.",
      tryAgainLater: "Si le problème persiste, veuillez réessayer plus tard.",
      licenceCheckedSuccessfully: "Permis vérifié avec succès",
      licenceSummaryAdded: "Résumé du permis ajouté au dossier client",
      creditScore: "Score de crédit",
      lastChecked: "Dernière vérification",
      recheckCreditScore: "REVÉRIFIER LE SCORE DE CRÉDIT",
      checkCreditScore: "VÉRIFIER LE SCORE DE CRÉDIT",
      proceedToPayment: "Passer au paiement",

      paymentOverview: "Aperçu du paiement",
      schedule: "Calendrier",
      contractDetails: "Détails du contrat",
      plan: "Plan",
      swaps: "Échanges",
      payableDeposit: "Dépôt à payer",
      customerVerification: "Vérification du client",
      provideAdditionalDetails:
        "Veuillez fournir les informations complémentaires dans la section compte pour créer la réservation",
      profilePhoto: "Photo de profil",
      submitYourRequest:
        "Une fois terminé, veuillez soumettre votre demande pour approbation en cliquant sur le bouton ci-dessous",
      submit: "Soumettre",

      uploadLicenceImages: "Télécharger les images du permis",
      add: "Ajouter",
      uploadFrontBackLicence:
        "Téléchargez les images avant et arrière du permis. Formats supportés : .png, .jpeg, .jpg !",
      uploadLicenceImage: "Télécharger l’image du permis",
      authority: "Autorité",
      drivingLicenceExpiryDate: "Date d’expiration du permis de conduire",
      licenceNumber: "Numéro du permis",
      preview: "Aperçu",
      addOn: "Supplément",
      contact: "Contact",

      selectSlot: "Sélectionner un créneau",
      deliveryType: "Type de livraison",
      experience: "Expérience",
      type: "Type",
      bookATestDrive: "Réserver un essai",
      selectASlot: "Sélectionner un créneau",
      selectDateTimeSlot: "Sélectionner une date et un créneau horaire",
      vehicleNotAvailable: "Véhicule non disponible pour la date sélectionnée",
      selectDifferentDate: "Veuillez sélectionner une autre date",
      selectCar: "Sélectionner une voiture",
      availableNow: "Disponible maintenant",
      new: "Nouveau",
      phone: "Téléphone",
      customerDetails: "Détails du client",
      dealershipAddress: "Adresse du concessionnaire",
      dealership: "Concessionnaire",
      bookingTime: "Heure de réservation",
      bookingType: "Type de réservation",
      details: "Détails",
      your: "Votre",
      confirmation: "Confirmation",
      selectDealership: "Sélectionner un concessionnaire",
      testDriveRequested: "Essai demandé",
      testDrive: "Essai",
      mobileNumber: "Numéro de mobile",
      drivingLicenseNumber: "Numéro de permis de conduire",
      enterLicenseNumber: "Saisir le numéro de permis",
      requestTestDrive: "Demander un essai",
      slot: "Créneau",
      vehicle: "Véhicule",

      selectSubsctiption: "SÉLECTIONNER L’ABONNEMENT",
      pricesShownOnSelectedDuration:
        "Les prix affichés sont basés sur la durée sélectionnée",
      priceComparison: "Comparaison des prix",
      oneTime: "Une fois",
      subscriptionStartsAt: "L’abonnement commence à",
      paymentProcessing: "Traitement du paiement",
      pleaseWait: "Veuillez patienter",
      paymentComplete: "Paiement effectué",
      paymentInProgress: "Paiement en cours",
      atleastUploadOne: "Téléchargez au moins une",
      upload: "Télécharger",
      uploadServiceNotAvailable: "Service de téléchargement non disponible. Veuillez réessayer.",
      uploading: "Téléchargement en cours...",
      atDealership: "Chez le concessionnaire",
      atHome: "À domicile",

      enterYourEmailPassword:
        "Saisissez votre adresse email et votre mot de passe pour vous connecter",
      enterMailHere: "Saisissez votre adresse email ici",
      required: "Requis",
      password: "Mot de passe",
      reset: "réinitialiser",
      otpForPasswordReset:
        "Vous recevrez un code OTP pour réinitialiser votre mot de passe par email",
      sendOtp: "Envoyer OTP",
      loginInstead: "Se connecter à la place",
      verifyOtp: "Vérifier OTP",
      otp: "OTP",
      otpSentToEmail: "Le code OTP a été envoyé à votre adresse email",
      enterOtp: "Saisir le code OTP",
      enterOtpHere: "Saisir le code OTP ici",
      verify: "Vérifier",
      setNewPassword: "Définir un nouveau mot de passe",
      eightCharLong: "Doit contenir au moins 8 caractères",
      reenterPassword: "Saisissez à nouveau le mot de passe ici",
      signInAs: "Se connecter en tant que",
      as: "En tant que",
      selectAccountToProceed: "Sélectionnez un compte pour continuer",
      personalAccount: "Compte personnel",
      asBusinessCustomer: "En tant que client professionnel",
      asDriver: "En tant que conducteur",
      enterPassword: "Saisir le mot de passe ici",
      registerAs: "S'inscrire en tant que",
      individual: "Individuel",
      business: "Professionnel",
      operatorMandatedCustomerCheck:
        "L’opérateur a exigé une vérification client avant la confirmation de la réservation. Veuillez attendre l’approbation.",
      createAccount: "Créer un compte",
      emailedHowToGetStarted:
        "Nous vous avons envoyé un email avec les instructions de démarrage.",
      ifDontSeeEmail:
        "Si vous ne voyez pas l’email dans quelques minutes, vérifiez dans le dossier ‘courrier indésirable’ ou ‘spam’.",

      previousVehicleDetails: "Détails du véhicule précédent",
      registration: "Immatriculation",
      makeModel: "Marque/Modèle",
      vin: "VIN",
      driverAssigned: "Conducteur assigné",
      currentVehicleDetails: "Détails du véhicule actuel",
      priceGroup: "Groupe tarifaire",
      unlimitedMileage: "Kilométrage illimité",
      paymentStatus: "Statut du paiement",
      invoiceNumber: "Numéro de facture",
      deliveryDetails: "Détails de livraison",
      collectionDetails: "Détails de la collecte",
      coiDetails: "Détails COI",
      policyName: "Nom de la police",
      planName: "Nom du plan",
      policyNumber: "Numéro de police",
      provider: "Fournisseur",
      vehicleSwapDetails: "Détails de l'échange de véhicule",
      swapMyCar: "Échanger ma voiture",
      NoOfSwapsAllowed: "Nombre d’échanges autorisés",
      NoOfSwapsAvailed: "Nombre d’échanges utilisés",
      NoOfSwapsRemaining: "Nombre d’échanges restants",
      swapRequestHistory: "HISTORIQUE DES DEMANDES D'ÉCHANGE",
      requestedOn: "Demandé le",
      swapDate: "Date d'échange",
      oldVehicle: "Ancien véhicule",
      newVehicle: "Nouveau véhicule",
      addonsDetails: "Détails des options",
      paymentDetails: "Détails du paiement",
      billingPeriod: "Période de facturation",
      creationDate: "Date de création",
      invoiceType: "Type de facture",
      regular: "Régulière",
      depositDetails: "Détails du dépôt",
      amount: "Montant",
      totalPaidAmount: "Montant total payé",
      cancellationCharges: "Frais d’annulation",
      totalRefundAmount: "Montant total remboursé",
      anUnpaid: "une facture impayée",
      aPartiallyPaid: "une facture partiellement payée",
      thisIs: "Ceci est",
      pleaseContactUs: "Veuillez nous contacter pour toute question",
      reasonToCancelTheBooking:
        "Veuillez sélectionner un motif pour annuler la réservation",
      enterTheReason: "Saisissez le motif",
      dismiss: "Rejeter",
      selectVehicle: "Sélectionner un véhicule",
      bookingConfirmationInProgress: "Confirmation de la réservation en cours",
      pleaseProvideTheReason: "Veuillez fournir le motif",
      quote: "Devis",
      management: "Gestion",
      pickupDateTimePassed:
        "La date ou l’heure de prise en charge est passée, ou le montant est nul",
      profileRejectedOrPending: "Votre profil a été rejeté ou est en attente",

      testDriveAgreement: "Contrat d'essai de conduite",
      rentalAgreement: "Contrat de location",
      contractHireAgreement: "Contrat de location longue durée",
      subscriptionAgreement: "Contrat d'abonnement",
      zeroChargeBooking:
        "La réservation sans frais ne peut être confirmée que par l’opérateur",
      pickupDateTimeInPast:
        "La date et l’heure de prise en charge sont dans le passé",
      creditNoteSummary: "Résumé de l’avoir",
      customerName: "Nom du client",
      customerEmail: "Email du client",
      creditNoteRef: "Référence de l’avoir",
      invoiceRef: "Référence de la facture",
      totalAmount: "Montant total",
      amountAdjustedRefunded: "Montant ajusté/remboursé",
      amountAvailable: "Montant disponible",
      adjustments: "Ajustements",
      particulars: "Détails",
      adjustedToInvoice: "Ajusté à la facture",
      adjustedAt: "Ajusté le",
      creditNotes: "Avoirs",
      availableBalance: "Solde disponible",
      searchCreditNoteId: "Rechercher l’ID de l’avoir",
      active: "Actif",
      exhausted: "Épuisé",
      creditNoteId: "ID de l’avoir",
      dateGenerated: "Date de génération",
      amountRefunded: "Montant remboursé",
      amountRemaining: "Montant restant",
      dashboard: "Tableau de bord",
      activeVehiclesCount: "Nombre de véhicules actifs",
      totalActiveBookings: "Nombre total de réservations actives",
      totalVehicles: "Nombre total de véhicules",
      vehicleChecks: "Contrôles véhicule",
      inProgressBookings: "Réservations en cours",
      vehicleChecksCompleted: "Contrôles véhicule terminés",
      vehicleChecksPending: "Contrôles véhicule en attente",
      dailyBalance: "Solde quotidien",
      totalOutstanding: "Total impayé",
      UnpaidInvoices: "Nombre de factures impayées",
      regularInvoices: "Factures régulières",
      sundryInvoices: "Factures diverses",
      addNewDriver: "Ajouter un nouveau conducteur",
      phoneNo: "Numéro de téléphone",
      drivingLicenceImage: "Image du permis de conduire",
      licenceIssuedBy: "Permis délivré par",
      licenceExpiryDate: "Date d’expiration du permis",
      drivingLicenceIssueDate: "Date d'émission de permis de conduire",
      pcoIssueDate: "Date de délivrance de la licence PCO du conducteur",
      dateOfBirth: "Date de naissance",
      taskDetailsNotFound: "Détails de la tâche non trouvés.",
      bookingRef: "Référence de réservation",
      rateYourExperience: "Évaluez votre expérience",
      driverInformation: "Informations sur le conducteur",
      saveDrivers: "Enregistrer les conducteurs",
      expiry: "Expiration",
      areYouSureDriver: "Êtes-vous sûr de vouloir supprimer ce conducteur de",
      drivers: "Conducteurs",
      noDriverFound: "Aucun conducteur trouvé",

      invoices: "Factures",
      searchInvoiceId: "Rechercher l’ID de la facture",
      unpaid: "Impayée",
      paid: "Payée",
      void: "Annulée",
      invoiceId: "ID de la facture",
      invoiceDate: "Date de la facture",
      balanceDue: "Solde dû",
      dueDate: "Date d’échéance",
      invoiceSummary: "Résumé de la facture",
      invoice: "Facture",
      sundry: "Divers",
      addPayment: "Ajouter un paiement",
      customerPhoneNumber: "Numéro de téléphone du client",
      invoiceReference: "Référence de la facture",
      period: "Période",
      invoiceVoidedBy: "Facture annulée par",
      invoicePeriod: "Période de facturation",
      invoiceStatus: "Statut de la facture",
      invoiceAmount: "Montant de la facture",
      amountDue: "Montant dû",
      generatedAt: "Généré le",
      vehicleRentalCharges: "Frais de location du véhicule",
      refundable: "Remboursable",
      date: "Date",
      thisIsTestCourtsey: "Ceci est un test / courtoisie",
      invoicesConsolidated: "Factures consolidées",
      payments: "Paiements",
      exempted: "exempté",
      pleaseLoginFirst: "Veuillez vous connecter d'abord",
      account: "Compte",
      tracking: "Suivi",
      uploadImages: "Téléverser des images",
      updateVehicleState: "Mettre à jour l’état du véhicule",
      vehicleImage: "Image du véhicule",
      fuelStatus: "Niveau de carburant",
      batteryStatus: "Niveau de batterie",
      odometerReading: "Kilométrage",
      nextServiceDetails: "Prochain entretien",
      serviceType: "Type de service",
      serviceStatus: "Statut du service",
      appointmentDate: "Date de rendez-vous",
      estdCompletionDate: "Date estimée de fin",
      serviceProviderName: "Nom du prestataire de service",
      serviceProviderAddress: "Adresse du prestataire de service",
      notesForDriver: "Remarques pour le conducteur",
      exteriorDamages: "Dommages extérieurs",
      interiorDamages: "Dommages intérieurs",
      generalChecks: "Vérifications générales",
      accessoriesChecks: "Vérifications des accessoires",
      chooseFuelLevel: "Choisir le niveau de carburant",
      lastReported: "Dernier rapport",
      circumstance: "Circonstance",
      title: "Titre",
      damageKind: "Type de dommage",
      damageArea: "Zone de dommage",
      referenceNumber: "Numéro de référence",
      damageDetail: "Détail du dommage",
      addImage: "Ajouter une image",
      addImages: "Ajouter des images",
      done: "Terminé",
      searchExistingDriver: "Rechercher un conducteur existant",
      success: "Succès",
      assignDriver: "Attribuer un conducteur",
      plate: "Plaque",
      unassigned: "Non assigné",
      assigned: "Assigné",
      make: "Marque",
      vehicleAppearOnceAssigned:
        "Les véhicules apparaîtront une fois assignés !",
      searchVehicle: "Rechercher un véhicule",
      trackingHistoryHrs: "Historique de suivi (heures)",
      telemetryDevice: "Dispositif de télémétrie",
      lastLocation: "Dernière localisation",
      latitude: "Latitude",
      longitude: "Longitude",
      forSelectedPeriod: "Pour la période sélectionnée -",
      milesDriven: "Miles parcourus",
      engineHours: "Heures moteur",
      fuelUsageLitres: "Consommation de carburant (litres)",
      stoppagehours: "Heures d’arrêt",
      chargeStatus: "État de charge",
      fuelUsage: "Consommation de carburant",
      batteryLevel: "Niveau de batterie",
      speedLimit: "Limite de vitesse",
      invalidEmailAddress: "Adresse e-mail invalide",
      unableLoadCompanyDetails:
        "Impossible de charger les détails de l’entreprise",
      bookingConfirmationProgress: "Confirmation de la réservation en cours...",
      doNotHitBack:
        "Veuillez ne pas revenir en arrière, annuler ou fermer le navigateur. Ce processus peut prendre jusqu’à 2 minutes...",
      summary: "Résumé",
      addNew: "Ajouter un nouveau",
      street: "Rue",
      city: "Ville",
      regionState: "Région / État",
      country: "Pays",
      zipPostalCode: "Code postal",

      cardAuthorizeNowButAmountLater:
        "La carte sera autorisée maintenant mais le montant sera débité lorsque la réservation commencera",
      saveThisCardForFutureInvoicesBooking:
        "Enregistrez cette carte pour effectuer le paiement des factures futures sur cette réservation.",
      confirmBookingPayLater: "Confirmer la réservation, payer plus tard",
      confirmBookingAndPayAtPickup:
        "Confirmer la réservation maintenant et payer au moment du retrait",
      bookingReferenceNumber: "Numéro de référence de la réservation",
      pickupDetails: "Détails du retrait",
      dropoffDetails: "Détails du retour",
      to: "À",
      bookingReference: "Référence de réservation",
      invoiceStartDate: "Date de début de la facture :",
      invoiceEndDate: "Date de fin de la facture :",
      availableAtLocations: "Disponible aux emplacements",
      benefits: "Avantages",
      passportNumber: "Numéro de passeport",
      enterPassportNumber: "Entrez votre numéro de passeport",

      vehicleSwapRequest: "Demande de changement de véhicule",
      checkVehicleAvailability: "Vérifier la disponibilité du véhicule",
      pleaseSelectDateAndSearch:
        "Veuillez sélectionner une date et cliquer sur Rechercher pour la disponibilité",
      noVehicleFoundForSelectedDate:
        "Aucun véhicule trouvé pour la date sélectionnée",
      notes: "Remarques",
      writeYourNoteHere: "Écrivez votre note ici",
      updateRequest: "Mettre à jour la demande",
      generateRequest: "Générer une demande",
      cancelRequest: "Annuler la demande",
      operator: "Opérateur",
      you: "Vous",
      maximum: "Maximum",
      imagesAreAllowed: "images sont autorisées à être téléchargées.",
      dragAndDropFile: "Glissez-déposez un fichier ou cliquez",
      areAllowed: "sont autorisés",
      cancelBooking: "Annuler la réservation",
      booked: "Réservé",
      organisation: "Organisation",
      vatNumber: "Numéro de TVA",
      sort: "Trier",
      DELETE_DRIVER_DESCRIPTION:
        "Êtes-vous sûr de vouloir supprimer le conducteur ?",
      driverActions: {
        "Are you sure you want to delete the driver?":
          "Êtes-vous sûr de vouloir supprimer le conducteur ?",
        "Delete Driver": "Supprimer le conducteur",
      },
      currentInvoiceStatus: {
        PAID: "PAYÉ",
        UNPAID: "IMPAYÉ",
        VOID: "ANNULÉ",
        "PARTIALLY PAID": "PARTIELLEMENT PAYÉ",
        DRAFT: "BROUILLON",
      },
      currentBookingStatus: {
        CANCELLED: "ANNULÉ",
        COMPLETED: "TERMINÉ",
        "CONFIRMATION IN PROCESS": "CONFIRMATION EN COURS",
        CONFIRMED: "CONFIRMÉ",
        "IN PROGRESS": "EN COURS",
        QUOTE: "DEVIS",
        DRAFT: "BROUILLON",
        "REQUIRES APPROVAL": "NÉCESSITE UNE APPROBATION",
        DECLINED: "REFUSÉ"
      },
      minBookingDurationMessage:
        "La durée minimale de réservation est de {{hours}} heures. Veuillez ajuster la date et l'heure de prise en charge ou de retour en conséquence.",
      maxBookingDurationMessage:
        "La durée maximale de réservation est de {{days}} jours. Veuillez ajuster la date et l'heure de prise en charge ou de retour en conséquence.",
      usevaletTypes: {
        Delivery: "Livraison",
        Collection: "Collecte",
        "Delivery and Collection": "Livraison et collecte",
      },
      selectCollectionSlot: "Sélectionner un créneau de collecte",
      driverUnavailableNote:
        "Remarque : Le conducteur n'est pas disponible, veuillez contacter l'opérateur de location.",
      cancellationReasons: {
        "Requirement changed": "Le besoin a changé",
        Price: "Prix",
        Other: "Autre",
      },
      imagePreview: "Aperçu de l'image",
      markDamage: "Marquer les dommages",
      vehicleDamageImages: "Images des dommages du véhicule",
      incidentDate: "Date de l'incident",
      incidentTime: "Heure de l'incident",
      clear: "Effacer",
      bookingStatus: "Statut de réservation",
      daysInBooking: "Jours dans la réservation",
      accumulatedDays: "jours accumulés",
      endingThisMonth: "Terminer ce mois",
      creditUtilisation: "Utilisation du crédit",
      creditLimit: "Limite de crédit",
      utilized: "Utilisé",
      totalDrivers: "Total conducteur",
      vehiclesAllocated: "Véhicules alloués",
      mileageOverview: "Présentation du kilométrage",
      mileageLimitExited: "Limite de kilométrage sorti",
      approachingMileageLimits: "Approche des limites de kilométrage",
      motReminders: "Rappels MOT",
      totalMotTests: "Tests MOT totaux",
      healthCheckReminders: "Rappels de bilan de santé",
      totalHealthCheckTests: "Total des tests de contrôle de santé",
      failed: "Échoué",
      serviceReminders: "Rappels de service",
      overdue: "En retard",
      totalServiceReminders: "Rappels de service total",
      createNewServiceRequest: "Créer une nouvelle demande de service",
      serviceDetails: "Détails du service",
      selectedVehicle: "Véhicule sélectionné",
      serviceRequestSelectVehicle: "Sélectionner un véhicule",
      loadingVehicles: "Chargement des véhicules...",
      noActiveVehiclesFound: "Aucun véhicule actif trouvé",
      addDetails: "Ajouter des détails",
      addItems: "Ajouter des éléments",
      issueType: "Type de problème",
      issueTypePlaceholder: "par ex., Serrure cassée",
      descriptionPlaceholder: "par ex., Serrure de porte avant gauche",
      uploaded: "Téléchargé",
      additionalComments: "Commentaires supplémentaires",
      additionalCommentsPlaceholder: "Ajoutez toute information supplémentaire...",
      submitting: "Envoi en cours...",
      submitRequest: "Envoyer la demande",
      serviceRequestNote: "Votre demande sera examinée par notre équipe de service. Vous recevrez une notification une fois qu'elle sera approuvée ou si des informations supplémentaires sont nécessaires.",
      serviceRequestDetails: "Détails de la demande de service",
      createdDate: "Date de création",
      estimatedCost: "Coût estimé",
      requestProgress: "Progression de la demande",
      issuesReported: "Problèmes signalés",
      issue: "Problème",
      imageAlt: "Image",
      serviceProvider: "Fournisseur de services",
      appointment: "Rendez-vous",
      at: "à",
      estimatedCompletion: "Achèvement estimé",
      workToBeDone: "Travaux à effectuer",
      cost: "Coût",
      totalCost: "Coût total",
      requestDeclined: "Demande refusée",
      communication: "Communication",
      serviceTeam: "Équipe de service",
      noCommunicationYet: "Pas encore de communication",
      addMessage: "Ajouter un message",
      askQuestionPlaceholder: "Posez une question ou fournissez des informations supplémentaires...",
      sending: "Envoi...",
      sendMessage: "Envoyer le message",
      additionalInformationRequested: "Informations supplémentaires demandées",
      provideFollowingInformation: "Veuillez fournir les informations suivantes pour nous aider à traiter votre demande:",
      yourAnswer: "Votre réponse:",
      typeAnswerHere: "Tapez votre réponse ici...",
      submitAnswers: "SOUMETTRE LES RÉPONSES",
      approved: "Approuvé",
      serviceRequests: "Demandes de Service",
      scheduledServicesTitle: "Services planifiés",
      scheduledServicesBellAria: "Afficher les services véhicule planifiés",
      noScheduledServices: "Aucun service planifié",
      approveScheduledServiceSuccess: "Service approuvé avec succès",
      requestChangesSuccess: "Demande de modification envoyée pour approbation",
      requestChanges: "Demander des modifications",
      modifyServiceRequest: "Modifier la demande de service",
      modifyDetails: "Modifier les détails",
      vehicleAndCategory: "Véhicule et catégorie",
      cannotModify: "Modification impossible",
      appointmentDetails: "Détails du rendez-vous",
      time: "Heure",
      scheduledServiceReviewHint: "Veuillez examiner le service planifié. Approuvez si les détails sont corrects, ou demandez des modifications.",
      approveService: "Approuver le service",
      jobSheet: "Fiche de travail",
      declined: "Rejeté",
      lastUpdated: "Dernière mise à jour",
      explainChangesPlaceholder: "Expliquez pourquoi vous avez besoin de ces modifications...",
      submitChanges: "Soumettre les modifications",
      expenses: "Dépenses",
      filters: "Filtres",
      applyFilters: "Appliquer les Filtres",
      activeFilters: "Filtres Actifs",
      newServiceRequest: "Nouvelle Demande de Service",
      rowsPerPage: "Lignes par page:",
      of: "de",
      moreThan: "plus de",
      searchServiceRequestsPlaceholder: "Rechercher par numéro de référence, véhicule ou statut...",
      selectOption: "Sélectionner une option",
      selectMultiple: "Sélectionner une ou plusieurs options",
      uploadPhoto: "Télécharger une photo",
      view: "Voir",
      typeYourResponse: "Tapez votre réponse",
      pleaseSelectServiceType: "Veuillez sélectionner un type de service",
      pleaseSelectServiceCategory: "Veuillez sélectionner une catégorie de service",
      selectServiceType: "Sélectionner le type de service",
      serviceCategory: "Catégorie de service",
      selectServiceCategory: "Sélectionner la catégorie de service",
      unableToDetermineServiceBranch: "Impossible de déterminer votre branche de service. Veuillez réessayer plus tard.",
      accidentDamageInformation: "Informations sur l'accident / les dommages",
      documentUploads: "Téléchargement de documents",
      adHoc: "Ad-Hoc",
      emergency: "Urgence",
      serviceQuestionnaire: "Questionnaire de Service",
      serviceQuestionnaireDescription: "Fournissez quelques détails supplémentaires pour que notre équipe de service puisse tout préparer à l'avance.",
      selectServiceCategoryPrompt: "Sélectionnez une catégorie de service pour voir les questions requises pour ce service.",
      noServiceQuestionsForType: "Aucune question supplémentaire pour ce type de service. Vous pouvez continuer avec la demande.",
      fileUploadGuidance: "JPEG/PNG jusqu'à 5 Mo par fichier.",
      optionalServiceQuestion: "Question optionnelle — répondez si cela aide notre équipe.",
      requestCreated: "Demande créée",
      underReview: "En cours d'examen",
      inProgress: "En cours",
      photo: "Photo",
      hiThere: "Bonjour,",
      serviceRequestDeclinedMessage: "Nous avons examiné votre demande de service, mais elle n'a pas pu être approuvée pour le moment.",
      whatWeNeed: "Ce dont nous avons besoin :",
      declineReasonGeneric: "Cela peut être dû à des détails manquants, à l'éligibilité au service ou à d'autres conditions d'approbation.",
      declineInstruction: "Veuillez examiner vos informations et soumettre une nouvelle demande une fois ces mises à jour en place.",
      answered: "Répondu",
      pendingAnswer: "En attente de réponse",
      requiredField: "Cette réponse est requise",
      questionsAnswered: "questions répondues",
      readyToSubmitChanges: "Prêt à soumettre les mises à jour",
      questionsUpToDate: "Toutes les réponses sont à jour",
      updateAnyAnswerToResubmit: "Mettez à jour n'importe quelle réponse ci-dessus si vous devez envoyer de nouvelles informations.",
      answerTypeText: "Texte",
      answerTypeYesNo: "Oui / Non",
      answerTypeDropdown: "Menu déroulant",
      answerTypeMultiSelect: "Sélection multiple",
      answerTypeFileUpload: "Téléchargement de photo",
      pendingApproval: "En attente d'approbation",
      awaitingMoreInformation: "En attente de plus d'informations",
      closed: "Fermé",
      noServiceRequestsFound: "Aucune demande de service trouvée",
      fleetAllocation: "Affectation de Flotte",
      fleetAllocations: "Affectations de Flotte",
      userAgreement: "Accord Utilisateur",
      organisationCode: "Code de l'Organisation",
      serviceReference: "Référence du Service",
      completionDate: "Date d'Achèvement",
      addTask: "Ajouter une Tâche",
      noTaskFound: "Aucune tâche trouvée. Vous pouvez ajouter des tâches manuellement.",
      taskName: "Nom de la Tâche",
      features: "Fonctionnalités",
      interiorFeatures: "Équipements Intérieurs",
      exteriorFeatures: "Équipements Extérieurs",
      safetyAndTechnicalFeatures: "Équipements de Sécurité et Techniques",
      otherFeatures: "Autres Équipements",
      privateHiresNo: "Embauche privée non",
      pcoPrivateHiresHireDLNo: "PCO / Private Hire DL Non",
      gender: "Genre",
      secondaryEmailAddress: "Adresse e-mail secondaire",
      secondaryPhoneNumber: "Numéro de téléphone secondaire",
      driverAge: "Âge du conducteur",
      licenceDuration: "Durée de la licence",
      penaltyPoints: "Points de pénalité",
      insuranceClaimsHistory: "Historique des réclamations d'assurance",
      pcoExpiryDate: "Date d'expiration PCO",
      state: "État",
      selectBookingType: "Sélectionner le type de réservation",
      selectBookingTypeDialog: "Veuillez sélectionner l’un des types de réservation ci-dessous pour continuer",
      regularBooking: "Réservation standard",
      contactlessBooking: "Réservation sans contact",
      reviewBookingDetails: "Vérifier les détails de la réservation",
    },
    validation: {
      otpLengthMismatch: "La longueur du code OTP doit être de 6 caractères.",
      invalidOtp: "OTP invalide",
      required: "{{field}} est requis",
      billingEmailInvalid:
        "Veuillez entrer une adresse e-mail de facturation valide.",
      billingEmailRequired: "L'adresse e-mail de facturation est requise.",
      phoneNumberRequired: "Le numéro de téléphone est requis.",
      businessNameRequired: "Le nom de l'entreprise est requis.",
      registrationNumberRequired: "Le numéro d'enregistrement est requis",
      vatRequired: "Le numéro de TVA/impôt est requis",
      accountNumberRequired: "Le numéro de compte est requis",
      registeredAddressRequired: "L'adresse enregistrée est requise.",
      registeredAddressCountryRequired: "Le pays est requis.",
      registeredAddressStateRequired: "L'état / région est requis.",
      registeredAddressCityRequired: "La ville est requise.",
      registeredAddressStreetRequired: "La rue est requise.",
      tradingAddressRequired: "L'adresse commerciale est requise.",
      tradingAddressCountryRequired: "Le pays est requis.",
      tradingAddressStateRequired: "L'état / région est requis.",
      tradingAddressCityRequired: "La ville est requise.",
      tradingAddressStreetRequired: "La rue est requise.",
      contactEmailRequired: "L'adresse e-mail de contact est requise.",
      firstNameRequired: "Le prénom est requis.",
      middleNameRequired: "Le deuxième prénom est obligatoire.",
      lastNameRequired: "Le nom de famille est requis.",
      addressRequired: "L'adresse est requise.",
      locationRequired: "L'emplacement est requis.",
      emailIsRequired: "L'adresse e-mail est requise.",
      termsConditionsAccepted:
        "Les conditions générales doivent être acceptées.",
      streetZipcodeRequired: "Rue / code postal est requis.",
      drivingLicenceNumberRequired:
        "Le numéro du permis de conduire est requis.",
      nationalInsuranceNumberRequired:
        "Le numéro de sécurité sociale est requis.",
      nationalityRequired: "La nationalité est requise.",
      enterValidPhoneNumber: "Veuillez entrer un numéro de téléphone valide.",
      enterValidEmailAddress: "Veuillez entrer une adresse e-mail valide.",
      authorityRequired: "L'autorité est requise.",
      licenceNumberRequired: "Le numéro de permis est requis.",
      licenceExpiryDateRequired: "La date d’expiration du permis est requise.",
      expiryDateRequired: "La date d’expiration est requise.",
      numberIsRequired: "Le numéro est requis.",

      passwordLengthValidaion:
        "Le mot de passe doit contenir au moins 8 caractères.",
      passwordContainUppercase:
        "Le mot de passe doit contenir au moins une lettre majuscule.",
      passwordContainLowercase:
        "Le mot de passe doit contenir au moins une lettre minuscule.",
      passwordContainOneNumber:
        "Le mot de passe doit contenir au moins un chiffre.",
      passwordContainSpecialCharacter:
        "Le mot de passe doit contenir au moins un caractère spécial.",
      passwordMustMatch: "Les mots de passe doivent correspondre.",
      atleastOneUppercase: "Au moins une lettre majuscule.",
      atleastOneLowercase: "Au moins une lettre minuscule.",
      atleastOneNumericalChar: "Au moins un caractère numérique.",
      atleastOneSpecialChar: "Au moins un caractère spécial.",
      pleaseEnterAValidEmail: "Veuillez entrer une adresse e-mail valide.",
      driverNotFound: "Conducteur non trouvé.",
      batteryStatusNumber: "L’état de la batterie doit être un nombre.",
      batteryStatusCantNegative:
        "L’état de la batterie ne peut pas être négatif.",
      batteryStatusCantMoreHundred:
        "L’état de la batterie ne peut pas dépasser 100 %.",
      batteryStatusRequired: "L’état de la batterie est requis.",
      odometerReadingMustNumber: "Le kilométrage doit être un nombre.",
      odometerReadingRequired: "Le kilométrage est requis.",
      odometerMustEqualOrHigherLast:
        "Le kilométrage doit être égal ou supérieur à la dernière valeur signalée.",
      titleIsRequired: "Le titre est requis.",
      damageKindIsRequired: "Le type de dommage est requis.",
      descriptionIsRequired: "La description est requise.",
      damageImageIsRequired: "L’image du dommage est requise.",
      professionIsRequired: "La profession est requise",
      passportNineCharacters:
        "Le numéro de passeport doit être de 9 caractères",
      passportIsRequired: "Le passeport est requis",
      organisationCodeRequired: "Le code de l’organisation est requis",
      userNotFound: "Utilisateur non trouvé",
      invalidPassword: "Mot de passe invalide",
      passwordLengthError: "La longueur du mot de passe doit être d'au moins 8 caractères",
      customerPCONumberRequired: "Le numéro PCO / licence de location privée est requis",
      genderRequired: "Le genre est requis",
    },
    misc: {
      edit: "Modifier",
      logOut: "Se déconnecter",
      licence: "Permis",
      cancel: "Annuler",
      save: "Enregistrer",
      status: {
        PENDING: "En attente",
        APPROVED: "Approuvé",
        DECLINED: "Refusé",
        IN_REVIEW: "En révision",
      },
      delete: "Supprimer",
      create: "Créer",
      signIn: "Se connecter",
      select: "Sélectionner",
      back: "Retour",
      error: "Erreur",
      yes: "Oui",
      no: "Non",
      payConfirm: "Payer et confirmer",
      clickToAdd: "Cliquer pour ajouter",
      close: "Fermer",
      download: "Télécharger",
      selectCaps: "SÉLECTIONNER",

      forgotPassword: "Mot de passe oublié",
      pleaseNote: "Veuillez noter",
      front: "Avant",

      columnKey: {
        "#": "#",
        Particulars: "Détails",
        Quantity: "Quantité",
        "Unit Price": "Prix unitaire",
        Duration: "Durée",
        "Discounted Price": "Prix réduit",
        "VAT/TAX": "TVA / Taxe",
        Amount: "Montant",
      },
      columnLabelToKeyMap: {
        ITEM: "ARTICLE",
        DESCRIPTION: "DESCRIPTION",
        QUANTITY: "QUANTITÉ",
        "UNIT PRICE": "PRIX UNITAIRE",
        DURATION: "DURÉE",
        "DISCOUNTED PRICE": "PRIX RÉDUIT",
        "VAT/TAX": "TVA / TAXE",
        PRICE: "PRIX",
      },
      paymentColumnsKey: {
        Date: "Date",
        Amount: "Montant",
        "Mode Of Payments": "Mode de paiement",
        Status: "Statut",
      },
      consolidatedInvoicesColumnsKey: {
        "#": "#",
        "Invoice Reference Number": "Numéro de référence de la facture",
        "Vehicle Registration Numbers": "Numéro(s) d'immatriculation du véhicule"
      },
      buttonKey: {
        Rentals: "Locations",
        Subscriptions: "Abonnements",
        "Test Drive": "Essai",
        "Contract Hire": "Location longue durée",
      },
      subLabelKey: {
        "Book vehicle for hours and days":
          "Réservez un véhicule à l’heure ou à la journée",
        "Subscribe vehicle for weekly/monthly":
          "Abonnez-vous à un véhicule à la semaine/mois",
        "Test Drive our Premium Vehicles":
          "Essayez nos véhicules haut de gamme",
        "Contract Hire vehicle for weekly/monthly":
          "Location longue durée à la semaine/mois",
      },
      buttonTextKey: {
        "Subscribe Now": "S’abonner maintenant",
        "Book Now": "Réserver maintenant",
        "Contract Now": "Signer maintenant",
      },
      featuresKey: {
        "Flexible Leasing Options": "Options de location flexibles",
        "Choose the duration of your subscription as you go":
          "Choisissez la durée de votre abonnement au fur et à mesure",
        "Change car anytime*": "Changez de voiture à tout moment*",
        "Home delivery option": "Option de livraison à domicile",
        "100% digital": "100% numérique",
        "MOT and taxes": "Contrôle technique et taxes",
        "Without down payment": "Sans acompte",
        "Vehicle Servicing": "Entretien du véhicule",
      },
      adjustmentColumnKey: {
        "#": "#",
        Amount: "Montant",
        "Adjusted To Invoice": "Ajusté à la facture",
        "Adjusted At": "Ajusté le",
      },
      categoriesKey: {
        Knowledge: "Connaissances",
        Behavior: "Comportement",
        Punctuality: "Ponctualité",
      },
    },
    snackBar: {
      customerInfoSaved: "Informations client enregistrées",
      documentDeleted: "Document supprimé avec succès",
      documentDeleteFailed: "Échec de la suppression du document",
      documentDeleteError: "Erreur lors de la suppression du document",
      documentMarkedForDeletion:
        "Document marqué pour suppression. Les modifications seront appliquées lors de l'enregistrement.",
      profileImageUploaded: "Image de profil téléchargée avec succès",
      uploadImageFormatError:
        "Veuillez uniquement télécharger des images au format .jpeg/.jpg/.png !",
      selectDocumentType: "Veuillez sélectionner le type de document",
      selectExpiryDate:
        "Veuillez sélectionner la date d’expiration du document",
      fileSizeExceeded50mb: "La taille du fichier dépasse la limite de 50 Mo",
      fileSizeExceeded5mb: "La taille du fichier dépasse la limite de 5 Mo",
      uploadSuccess: "Document téléchargé avec succès",
      invalidUploadFormat:
        "Veuillez uniquement télécharger des fichiers PDF, PNG, JPG ou JPEG",
      selectExpiryDateUpload:
        "Veuillez sélectionner une date d'expiration avant de télécharger",
      ImageUploaded: "Image téléchargée avec succès",

      invalidFileType:
        "Type de fichier invalide. Types autorisés : jpeg ou png",
      costCenterInfoMissing: "Informations sur le centre de coût manquantes !",
      selectedDriverAlreadyAdded:
        "Le conducteur sélectionné a déjà été ajouté.",
      driverSavedSuccessfully: "Conducteur enregistré avec succès.",
      additionalDriverCannotBeMore:
        "Le nombre de conducteurs supplémentaires ne peut pas dépasser la quantité d'add-ons",
      verificationStatusInReview:
        "Le statut de vérification est en cours d'examen",
      verificationStatusPending: "Le statut de vérification est en attente",
      quoteCreated: "Devis créé",
      bookingCreated: "Réservation créée",
      pickUpLocationEmpty: "Le lieu de prise en charge est vide",
      slotSelectionRequiredForNonNegotiable:
        "La sélection d’un créneau est requise.",
      protectionPlanMandatoryForPCOBooking:
        "Le plan de protection est obligatoire pour les réservations PCO",
      paymentAlreadyDone: "Paiement déjà effectué",
      fileBeingGenerated:
        "Fichier en cours de génération, veuillez réessayer plus tard",

      provideDeliveryAddress: "Veuillez fournir l'adresse de livraison !",
      noValidCreditReadingFound:
        "Aucune lecture de crédit valide trouvée pour cette entreprise.",
      noValidCreditScoreFound:
        "Aucun score de crédit valide trouvé. Cela peut être dû à un dépassement de la limite de vérifications de crédit",

      atleastOneLicenceImage: "Téléchargez au moins une image du permis",
      licenceImageUploaded: "Image du permis téléchargée avec succès",
      maximumTwoImageLicence:
        "Deux images maximum peuvent être téléchargées pour le permis !",
      imageUploadInProgress:
        "Veuillez patienter, téléchargement de l'image en cours !",

      errorFetchingSignedUrl: "Erreur lors de la récupération de l’URL signée",
      paymentFailed: "Échec du paiement, veuillez réessayer",
      paymentFailedReasonCardDetails:
        "Votre paiement a échoué ! Veuillez vérifier les détails de votre carte ou réessayer plus tard.",
      maximumTwoImage: "Deux images maximum peuvent être téléchargées pour",

      cancelledSuccessfully: "Annulé avec succès",
      selectReasonForCancel: "Veuillez saisir la raison de l’annulation",
      streetZipcodeRequired: "Rue / code postal requis",
      feedbackSaved: "Merci ! Votre avis a été enregistré",
      driverAlreadyAdded: "Le conducteur est déjà ajouté !",
      driverRemoved: "Conducteur supprimé avec succès",
      businessCustomerDriverDeleted:
        "Conducteur du client entreprise supprimé.",
      errorInSavingData: "Erreur lors de l'enregistrement des données",
      damageInformationSaved:
        "Informations sur les dommages enregistrées avec succès.",
      errorSavingData: "Erreur lors de l'enregistrement des données",
      problemTelematicsData: "Problème de chargement des données télématiques",

      verificationRequestSent: "Demande de vérification envoyée avec succès.",
      vehicleStateUpdated: "État du véhicule mis à jour",
      driverAdded: "Conducteur ajouté.",
      businessCustomerCreated: "Client professionnel créé.",
      uploadOnlyImageFiles: "Veuillez télécharger uniquement des fichiers image (PNG, JPEG, JPG)",
      imageSizeExceed5MB: "La taille de l'image ne doit pas dépasser 5 Mo",
      uploadFailed: "Échec du téléchargement",
      imagesUploadedSuccessfully: "image(s) téléchargée(s) avec succès!",
      failedToUploadImages: "Échec du téléchargement des images. Veuillez réessayer.",
      pleaseSelectVehicle: "Veuillez sélectionner un véhicule",
      pleaseFillInAllIssueDetails: "Veuillez remplir tous les détails du problème",
      serviceRequestCreatedSuccessfully: "Demande de service créée avec succès! Référence:",
      errorCreatingServiceRequest: "Erreur lors de la création de la demande de service",
      pleaseEnterNote: "Veuillez saisir une note",
      noteAddedSuccessfully: "Note ajoutée avec succès",
      errorAddingNote: "Erreur lors de l'ajout de la note",
      pleaseAnswerAllRemainingQuestions: "Veuillez répondre à toutes les {{count}} question{{plural}} restantes",
      answersSubmittedSuccessfully: "Réponses soumises avec succès! Votre demande est maintenant en cours d'examen.",
      errorSubmittingAnswers: "Erreur lors de l'envoi des réponses",
      serviceRequestNotFound: "Demande de service introuvable",
      errorLoadingServiceRequests: "Erreur lors du chargement des demandes de service",
      oneVehicleForContactless: "Un seul véhicule peut être sélectionné pour une réservation sans contact",
      oneVehicleForNonContactless: "Seul un véhicule sans contact ou Smartcar peut être sélectionné pour une réservation sans contact",
      contactlessVehicleCannotBeSelected: "Un véhicule sans contact ne peut pas être sélectionné pour une réservation standard",
      bookingDetailsCreated: "Détails de la réservation créés"
    },
  },
};